import React from 'react';
import {withTranslation} from 'react-i18next';
import {
  ThemeProvider,
  Modal,
  ModalHeader,
  ModalContent,
  Textarea,
  Textfield,
  Select,
  Button,
  IconButton,
  Notification
} from '@workboard/wobo-ui';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Clear from '@material-ui/icons/Clear';
import './suggestedTags.scss'
import ImgIconComp from '../../imgcomp'
import styled from 'styled-components';
import { krdetailConstants } from '../../../constants/krdetails.constants';
import GoalServices from '../../../services/goal.services';
import {autoResizeTextArea} from '../../../utils/common.js';
import MetricOwnerCommonModal from './key_results/metric-owner.component';
import KrCluster from '../kr-cluster/kr-cluster.component';
import NestedKrMmodal from '../modals/nested-kr-modal';
import DropdownComp from '../../dropdown/dropdown';
import { getIntervalOptions } from '../../../utils/metric';
import { isNumberWithComma, replaceNumericCommaValue } from '../../../utils/function';
import { CoauthorButton, getCoauthorConfig } from './coauthor';




const StyledIconButton = styled(IconButton)`
    width: 22px;
    height: 14px;
    svg {
      width: 18px;
      height: 18px;
    }
    color:#0072AB
`;
const StyledModal = styled(Modal)`
  ${ModalHeader} {
    padding: 10px 20px !important;
    h1 {
      font-size: 16px !important;
    }
  }
  ${ModalContent} {
    padding: 0px !important;
  }
`;

const StyledCoauthorButton = styled(CoauthorButton)({
  padding: 8,
  marginLeft: 8
})

class BasicKrComp extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      setKr: this.props.setKr,
      suggestedTagsArray: [],
      advancedOptionEn: this.props.advancedOptionEn,
      addKrFinished: this.props.addKrFinished,
      MeasureEn: false,
      name: this.props.addKrValue ? this.props.addKrValue : '',
      initial_data: this.props.krExtractInitialValue
        ? this.props.krExtractInitialValue
        : 0,
      inlineTarget: this.props.krExtractTargetValue
        ? this.props.krExtractTargetValue
        : '',
      counting: 1,
      measure: this.props.krExtractValueType
        ? this.props.krExtractValueType
        : 1,
      interval: 2,
      measureText: 'Count as number',
      intervalText:'Weekly',
      data_provider: {
        id: this.props.goalDetails ? this.props.goalDetails.owner_id : '',
        name: this.props.goalDetails
          ? this.props.goalDetails.owner_fullname
          : '',
        avatar: this.props.goalDetails.owner_pic,
      },
      ErrorDis: '',
      ErrorName: false,
      intervalEn: '',
      krOwnerEn: false,
      fields: {},
      saveBtn: this.props.btnState,
      ErrorDisstart: '',
      startMsg: 'Enter value',
      ownerSearchVal: '',
      clusterData: this.props.clusterItem ? this.props.clusterItem : [],
      nestedKrModalFlag: false,
      child_kr_duration: this.props.goalDetails.metricQuarterOption
        ? this.props.goalDetails.metricQuarterOption[0]
        : '',
      active: null,
      activeTagsData: [],
      nplTags: this.props.nlpTagLists ? this.props.nlpTagLists : [],
      activeTagsName: [],
      suggestedVisible: true.valueOf,
      tagsList: [],
      notification: false,
      currentTagname: '',
      severity: '',
      addRemove:''
    }
    this.saveKr = this.saveKr.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.deleteItem = this.deleteItem.bind(this)
    this.handleErrorChange = this.handleErrorChange.bind(this)
    this.changeDropDownVal = this.changeDropDownVal.bind(this)
    this.setRightPaneValue = this.setRightPaneValue.bind(this)
    this.GoalServices = new GoalServices()
    this.clickEvent = this.clickEvent.bind(this)
    this.onEnterPress = this.onEnterPress.bind(this)
    this.handleKrNameChange = this.handleKrNameChange.bind(this)
    this.refTarget = React.createRef()
    this.refTextArea = React.createRef()
    this.refInitialValue = React.createRef()
    this.coauthorNode = React.createRef();
  }

  activeArray = new Array(5).fill(null)
  componentDidUpdate(prevProps) {
    if (this.props.krExtractInitialValue !== prevProps.krExtractInitialValue
      || this.props.krExtractTargetValue !== prevProps.krExtractTargetValue
      || this.props.krExtractDirectionValue !== prevProps.krExtractDirectionValue
      || this.props.krExtractValueType !== prevProps.krExtractValueType ) {
      this.setState({
        initial_data: this.props.krExtractInitialValue,
        inlineTarget: this.props.krExtractTargetValue,
        measure: this.props.krExtractValueType,
        counting: this.props.krExtractDirectionValue,
        kr_name: this.props.krExtractName,
      })
    }
  }
  saveSuggestedNLPLTags = []
  toggleClass(index) {
    if (this.state.tagsList[index] === this.state.activeTagsData[index]) {
      this.saveSuggestedNLPLTags = []
      this.setState({ active: null })
      this.activeArray.splice(index, 1, null)
      this.setState({ activeTagsData: this.activeArray })
      this.activeArray.map(
        (item) => item && this.saveSuggestedNLPLTags.push(item.id)
      )
      this.setState({ activeTagsName: this.saveSuggestedNLPLTags })
      this.setState({ notification: true })
      this.setState({ severity: 'success' })
      this.setState({ currentTagname: this.state.tagsList[index].name })
      this.setState({ addRemove: 'removed from' })
    } else {
      this.setState({ notification: true })
      this.setState({ severity: 'success' })
      this.saveSuggestedNLPLTags = []
      this.activeArray.splice(index, 1, this.state.tagsList[index])
      this.setState({ currentTagname: this.state.tagsList[index].name })
      this.setState({ activeTagsData: this.activeArray })
      this.setState({ active: this.state.tagsList[index] })
      this.setState({ addRemove: 'applied to' })
      this.activeArray.map(
        (item) => item && this.saveSuggestedNLPLTags.push(item.id)
      )
      this.setState({ activeTagsName: this.saveSuggestedNLPLTags })
      this.krTagEvent([this.state.tagsList[index].id], true, true)
      this.krTagEvent([this.state.tagsList[index].id], true, false)
    }
  }
  toggleActiveIcon(index) {
    if (this.state.tagsList[index] === this.state.activeTagsData[index]) {
      return '✓'
    } else {
      return '+'
    }
  }
  toggleActiveClass(index) {
    if (this.state.tagsList[index] === this.state.activeTagsData[index]) {
      return 'tages-temp clicked'
    } else {
      return 'tages-temp unclicked'
    }
  }
  retnActiveClass(index) {
    if (this.state.tagsList[index] === this.state.activeTagsData[index]){
      return true;
    }else{
      return false;
    }
  }
  componentDidMount() {
    autoResizeTextArea(this.goalEditTextArea)
    let params = {}
    params.term = this.props.addKrValue
    this.GoalServices.getNlplTagsData(params).then((result) => {
      this.setState({ tagsList: result.data.data })
      if(this.state.tagsList.length > 0 ){
        let tagIds = this.state.tagsList.map(i => i.id)
        let params = {
          tagId : tagIds,
          ref : 'KR_TAG_SUGGESTION_VIEW',
          source : 'okr_wizard'
        }
        this.GoalServices.krTagEvents(params)
      }
    })
    if (this.state.name) {
      this.refTarget.current.querySelector('input').focus()
    } else {
      //this.refTextArea.current.querySelector("textarea").focus();
    }

    document.addEventListener('mousedown', this.clickEvent, false)

    window.addEventListener('coauthorSaveKeyResult', this.handleCoauthorSaveKeyResult);
  }

  componentWillUnmount() {
    window.removeEventListener('coauthorSaveKeyResult', this.handleCoauthorSaveKeyResult);
  }

  handleCoauthorSaveKeyResult = (e) => {
    const { value, originatorId } = e.detail;
    if (originatorId !== 'addKrValueTxtId') return;
    this.goalEditTextArea.value = value;
    this.handleKrNameChange({ target: { value }});
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.clusterItem !== prevState.clusterData) {
      return { clusterData: nextProps.clusterItem }
    } else return null
  }

  clickEvent(e) {
    if (
      !$('.measureDiv').is(e.target) &&
      $('.measureDiv').has(e.target).length === 0
    ) {
      if (this.state.MeasureEn) {
        this.setState({ MeasureEn: false })
      }
    }
    if (
      !$('.krTimeRange').is(e.target) &&
      $('.krTimeRange').has(e.target).length === 0
    ) {
      if (this.state.intervalEn) {
        this.setState({ intervalEn: false })
      }
    }
    if (
      !$('.ownerKrName').is(e.target) &&
      $('.ownerKrName').has(e.target).length === 0 &&
      !$('.myownerAlign ').is(e.target) &&
      $('.myownerAlign').has(e.target).length === 0
    ) {
      if (this.state.krOwnerEn) {
        this.setState({ krOwnerEn: false })
      }
    }
  }

  getFormData = () => {
    let obj = {
      counting: this.state.counting,
      progress_type: 1,
      name: this.state.name,
      metric: this.state.measure,
      interval: this.state.interval,
      owner: this.state.data_provider.id,
      ownerName: this.state.data_provider.name,
      ownerPic: this.state.data_provider.avatar,
      intervalText: this.state.intervalText,
      initial_data: this.state.initial_data,
      target: this.state.inlineTarget,
      krTagIds: this.state.activeTagsName,
    }
    if (this.props.isChildKr) {
      obj.duration = this.state.child_kr_duration
    }
    return obj
  }

  saveKr(e) {
    e.preventDefault()
    // const formData = {};
    // for (const field in this.refDict) {
    //     formData[field] = this.refDict[field].value;
    // }

    const formData = this.getFormData()
    let initial_data = replaceNumericCommaValue(this.state.initial_data)
    let target = replaceNumericCommaValue(this.state.inlineTarget)
    let name = this.state.name

    if (name != '' && target != '') {
      if (parseFloat(initial_data) > parseFloat(target)) {
        formData.counting = 2
      }
      this.props.saveKrs(formData, true)
    } else {
      if (target == '' || target == null) {
        this.setState(
          {
            ErrorDis: false,
          },
          () => {
            this.setState({ ErrorDis: true })
            this.refTarget.current.querySelector('input').focus()
          }
        )
      }

      if (initial_data == undefined ) {
        this.setState(
          {
            ErrorDisstart: false,
          },
          () => {
            this.setState({ ErrorDisstart: true })
            this.refInitialValue.current.querySelector('input').focus()
          }
        )
      }

      if (name == '') {
        this.setState(
          {
            ErrorName: false,
          },
          () => {
            this.setState({ ErrorName: true })
            this.goalEditTextArea.querySelector('textarea').focus()
          }
        )
      }
    }
  }

  // saveClusterAfterSave(id){
  // this.GoalServices.getClusterData({ goalId: this.props.goalDetails.id}).then(response => {
  //         if (response.status === 200) {
  //             this.props.actions.updateClusterData(response.data.data);
  //         }
  //     })
  // // this.props.actions.updateClusterDataForIndividualItem({clusterData :this.state.clusterData, id:id});
  // }

  handleChange(e) {
    let name = e.target.name
    let value = e.target.value
    const state = this.state
    if (value === '' || isNumberWithComma(value)) {
      state[name] = value
      state.ErrorDis = false
      state.ErrorDisstart = false
      state.ErrorName = false
      this.setState(state)
    }
    // if (value === "" || pattern.test(value)) {
    //     this.setState({ErrorDis: false, ErrorDisstart: false, ErrorName: false});
    // }
  }

  handleErrorChange(name, value) {
    const state = this.state
    state[name] = value
    this.setState(state)
  }

  deleteItem() {
    this.props.resetKr()
  }

  changeDropDownVal(from, id, text) {
    let name = from
    let value = id
    const state = this.state
    state[name] = value
    this.setState(state)
    if (from == 'measure') {
      this.setState({ measureText: text })
    }
    if (from == 'interval') {
      this.setState({ intervalText: text })
    }
    if (from == 'owner') {
      this.setState({ [data_provider['name']]: text })
    }
  }

  setRightPaneValue(nestedType = '') {
    // for (const field in this.refDict) {
    //     formData[field] = this.refDict[field].value;
    // }
    // this.saveSuggestedTags()
    const formData = this.getFormData()
    let krType
    if (nestedType == '1' || nestedType == '2') {
      krType = 'multipleIntervalTargets'
    } else if (nestedType == '3') {
      krType = 'nestedKrAPP'
    }
    if(this.props.isChildKr) {
      this.props.editMetricCompFun(
        formData,
        this.state.clusterData,
        krType
      )
    } else {
      this.props.editMetricCompFun(
        formData,
        this.state.clusterData,
        krType,
        this.state.activeTagsData,
        this.state.nplTags,
        this.state.activeTagsName,
        this.state.tagsList
      )
    }
  }

  styledButtonClicked = () => {
    const tagId = []
    this.setState({ suggestedVisible: false })
    this.setState({ activeTagsName: [] })
    this.setState({ activeTagsData: [] })
    this.state.tagsList.forEach((item)=>tagId.push(item.id))
    this.krTagEvent(tagId, false, false)
  }

  handleKrNameChange(e) {
    //autoResizeTextArea(this.goalEditTextArea);
    this.setState({
      name: e.target.value,
      ErrorName: false,
      ErrorDis: false,
      ErrorDisstart: false,
    })
    this.props.inlineKrUpdate(e.target.value)
  }

  onEnterPress(e) {
    if (e.keyCode === 13) {
      e.preventDefault()
    }
    autoResizeTextArea(this.goalEditTextArea)
  }

  updateDataProvider = (data) => {
    this.setState({
      data_provider: {
        id: data.userId,
        name: data.userText,
        avatar: data.userPic,
      },
    })
  }

  addClusterData = () => {
    if (this.props.displayKrClustering) {
      this.GoalServices.getClusterFireEvent({
        type: 'KR_CLUSTER_KR_NAME_CHANGED',
        source: 'KR_SIMPLE_CREATE',
      })
      this.GoalServices.getClusterData({
        goalId: this.props.goalDetails.id,
        metricId: 0,
        text: this.state.name,
      }).then((response) => {
        if (response.status === 200) {
          this.props.updateClusterData(response.data.data.metrics)
          if ($('.krNameSec').find('.krCluster')) {
            $('.krNameSec').find('.krCluster').addClass('ovalClicked')
            let clusterTimer = setInterval(() => {
              if ($('.krNameSec').find('.krCluster').hasClass('ovalClicked'))
                $('.krNameSec').find('.krCluster').removeClass('ovalClicked')
              else $('.krNameSec').find('.krCluster').addClass('ovalClicked')
            }, 300)
            setTimeout(() => {
              clearInterval(clusterTimer)
              if ($('.krNameSec').find('.krCluster').hasClass('ovalClicked'))
                $('.krNameSec').find('.krCluster').removeClass('ovalClicked')
            }, 3000)
          }
          // this.props.actions.updateClusterData(response.data.data);
        }
      })
    }
  }

  krTagEvent = (tagId, tagSelection, first) => {
    // first is true if api is called first time
    let ref = ''
    if(tagSelection && first){
      ref = 'KR_TAG_SUGGESTION_ACCEPTED'
    }
    if(tagSelection && !first){
      ref = 'KR_TAG_ADDED'
    }
    if(!tagSelection){
      ref = 'KR_TAG_SUGGESTION_DECLINED'
    }
    const source = 'kr_create'
    let params = {
      tagId : tagId,
      ref : ref,
      source : source
    }
    this.GoalServices.krTagEvents(params)
   }

  handleCoauthorClick = (e, value, placement = "bottom-start") => {
    const { goal, metrics } = this.props.goalDetails;
    window.openOkrCoauthor({
      type: "OPEN_KR_CHAT",
      initialDraft: value,
      anchor: e.target,
      placement,
      config: getCoauthorConfig(this.props.goalDetails),
      originator: { id: "addKrValueTxtId", type: "kr", krSlotIndex: -1 },
      initialDraftOKR: {
        objective: goal,
        keyResults: metrics?.map(m => m.name) ?? []
      }
    }, this.coauthorNode.current);
  }

  render() {
    const { displayKrClustering, t } = this.props
    let krMeasureOptions = [
      {
        name: t('Count as number'),
        value: 1,
      },
      {
        name: t('Count as currency'),
        value: 2,
      },
      {
        name: t('Count as percentage'),
        value: 3,
      },
    ]
    let krIntervalOptions = getIntervalOptions(
      'default',
      this.props.isEnabledBiweeklyKR,
      this.state.interval === krdetailConstants.INTERVAL_BIQUARTERLY
    )

    return (
      <ThemeProvider>
        <div className="krNameFilled" data-testid="krNameFilled">
          <div>
            <div className="krNameSec" data-testid="krNameSec">
              <div
                className="of-feature-selec inLineBlk"
                style={displayKrClustering ? { width: '71%' } : {}}
              >
                <label className="krLabelName" id="krSecName">
                  {t('Key result name')}
                </label>
                <Textarea
                  //classes
                  className="addKrValueTxt"
                  //className=
                  // ref={this.refTextArea}
                  placeholder={
                    this.props.isChildKr
                      ? t(`Write a quarterly key result that supports the success of your annual key result`)
                      : ''
                  }
                  value={this.state.name}
                  onChange={(event) => this.handleKrNameChange(event)}
                  onKeyDown={(event) => this.onEnterPress(event)}
                  onFocus={this.moveCaretAtEnd}
                  ref={(node) => (this.goalEditTextArea = node)}
                  //defaultValue={this.state.name}
                  onBlur={this.addClusterData}
                  isError={this.state.ErrorName}
                  helperText={this.state.ErrorName ? t('Enter name') : null}
                  data-testid="addKrValueTxt"
                  aria-labelledby="krSecName"
                  id="addKrValueTxtId"
                />
              </div>
              {displayKrClustering && this.state.clusterData.length > 0 && (
                <KrCluster
                  arrowClass="centerAligned"
                  iconClass="iconClass iconClassVertical"
                  popupClass={
                    this.props.isChildKr ? 'clusterRight' : 'clusterCenter'
                  }
                  updateKRStates={this.props.updateKRStates}
                  metric={{
                    goal_id: this.props.goalDetails.id,
                    owner: this.props.goalDetails.owner_id,
                    clusterItems: this.state.clusterData,
                    clusterCount: this.state.clusterData.length,
                  }}
                  actions={this.props.actions}
                  clusterItem={this.state.clusterData}
                  isChildKr={this.props.isChildKr}
                  saveNestedKRs={this.props.saveKrs}
                  childKrDuration={this.state.child_kr_duration}
                />
              )}
              <IconButton
                aria-label={t("delete key result")}
                onClick={this.deleteItem}
              >
                <DeleteOutline />
              </IconButton>
              <StyledCoauthorButton variant="icon" size="large" onClick={e => this.handleCoauthorClick(e, this.state.name, "bottom-end")} />
              <div ref={this.coauthorNode} />
            </div>
            <div className="krstarttargetsec">
              {this.props.isChildKr && (
                <div className="verticalTop inLineBlk nativeDropdown basicKrDuration">
                  {/* <Select
                                label="Duration"
                                className="kr-duration-select"
                                aria-label="This listbox lets you select kr duration"
                                autoWidth
                                isRequired
                                options = {this.props.goalDetails.metricQuarterOption }
                                getOptionLabel={({name}) => name}
                                onChange={(e, item) => this.changeDropDownVal("child_kr_duration", item)}
                                // getOptionSelected={(option, value) => console.log(option)}
                                value={this.state.child_kr_duration}
                                defaultValue={this.props.goalDetails.metricQuarterOption[0]}
                                panelProps={{
                                    className: 'kr-duration-select-dropdown',
                                    placement: 'bottom-start',
                                    disablePortal: true,
                                }}
                                /> */}
                  <div className="nativelabel">
                    {t('Duration')}<span className="asterik">*</span>
                  </div>
                  <DropdownComp
                    //labelText="Show:"
                    wrapperClass="basicKrDropdown"
                    defaultValue={
                      this.state.child_kr_duration
                        ? this.state.child_kr_duration.value
                        : 0
                    }
                    options={this.props.goalDetails.metricQuarterOption}
                    onChange={(e,item) =>
                      this.changeDropDownVal('child_kr_duration', item)
                    }
                    appendId="basic-kr-duration"
                  />
                </div>
              )}
              <div className="verticalTop inLineBlk">
                <Textfield
                  type="text"
                  label={t("Starting value")}
                  name="initial_data"
                  ref={this.refInitialValue}
                  isRequired
                  variant="outlined"
                  value={this.state.initial_data}
                  onChange={this.handleChange}
                  isError={this.state.ErrorDisstart ? true : false}
                  helperText={this.state.ErrorDisstart ? 'Enter value' : ''}
                  className={`krs-start-value`}
                  autoComplete="off"
                />
              </div>
              <div className="verticalTop supportText inLineBlk"> {t('to')}</div>
              <div className="verticalTop inLineBlk">
                <Textfield
                  type="text"
                  name="inlineTarget"
                  label={t("Target value")}
                  isRequired
                  ref={this.refTarget}
                  variant="outlined"
                  value={this.state.inlineTarget}
                  onChange={this.handleChange}
                  isError={this.state.ErrorDis ? true : false}
                  className={`krs-start-value`}
                  autoComplete="off"
                  helperText={this.state.ErrorDis ? t('Enter target') : ''}
                  data-testid="target"
                />
              </div>
              <div className="verticalTop inLineBlk nativeDropdown basicKrMeasure">
                {/* <Select
                                    label="Unit of measurement"
                                    className={`kr-measure-select ${this.props.isChildKr ? "child-kr-measure-select" : ""}`}
                                    aria-label="This listbox lets you select different kr measure options"
                                    autoWidth
                                    isRequired
                                    options = {krMeasureOptions}
                                    getOptionLabel={({name}) => name}
                                    onChange={(e, item) => this.changeDropDownVal("measure", item.value, item.text)}
                                    // getOptionSelected={(option, value) => console.log(option)}
                                    value={krMeasureOptions.find((f) => f.value === this.state.measure)}
                                    defaultValue={krMeasureOptions[0]}
                                    panelProps={{
                                        className: 'kr-measure-select-dropdown',
                                        placement: 'bottom-start',
                                        disablePortal: true,
                                    }}
                                /> */}
                                <div className="nativelabel uom-label">{t('Unit of measurement')}<span className="asterik">*</span></div>
                                <DropdownComp
                                    //labelText="Show:"
                                    wrapperClass = {`basicKrDropdown kr-measure-select ${this.props.isChildKr ? "child-kr-measure-select" : ""}`}
                                    defaultValue = {this.state.measure}
                                    //defaultValue={krMeasureOptions.find((f) => f.value === this.state.measure)}
                                    options={krMeasureOptions}
                                    onChange={(e, item) => this.changeDropDownVal("measure", item.value, item.text)}
                                    appendId="basic-kr-measure"
                                />
                            </div>
                        </div>
                        <label id="krMetricName" className="krLabelName">{t('Person responsible for updating')}</label>
                        <div className="krstarttargetsec marginBottom30px">
                            <MetricOwnerCommonModal item={
                                    this.state.data_provider
                                }
                                updateData={
                                    this.updateDataProvider
                                }
                                teamId = {this.props.teamId}
                                scrollElClass="goalPopupNew"
                                metric_id="krMetricName"
                                addId="basicMetrictarttargetsecId"
                            />
                            <div className="verticalTop supportText inLineBlk" style={{alignSelf: "center", top: 0}}>{t('to update')}</div>
                            <div className="verticalTop inLineBlk nativeDropdown basicKrInterval"
                                onClick={
                                    event => {
                                        this.setState({
                                            intervalEn: !this.state.intervalEn
                                        });
                                    }
                            }>
                             {/* <Select
                                className="kr-interval-select"
                                aria-label="This listbox lets you select different kr interval options"
                               // autoWidth
                                options = {krIntervalOptions}
                                getOptionLabel={({ text }) => text}
                                onChange={(e, item) => this.changeDropDownVal("interval", item.value, item.text)}
                                value={krIntervalOptions.find((f) => f.value == this.state.interval)}
                                defaultValue={krIntervalOptions[0]}
                                panelProps={{
                                    className: 'kr-measure-select-dropdown',
                                    placement: 'bottom-start',
                                    disablePortal: true,
                                }}
                                /> */}
                <DropdownComp
                  //labelText="Show:"
                  wrapperClass={`basicKrDropdown kr-interval-select week-dropdown ${
                    this.props.isChildKr ? 'child-kr-interval-select' : ''
                  }`}
                  defaultValue={this.state.interval}
                  //defaultValue={krMeasureOptions.find((f) => f.value === this.state.measure)}
                  options={krIntervalOptions}
                  onChange={(e,item) =>
                    this.changeDropDownVal('interval', item.value, item.text)
                  }
                  appendId="basic-kr-interval"
                />
              </div>
            </div>
            {this.props.reqFieldError && <div>
              <p style={{color:"red",marginTop:"-20px"}}>*{t('Please fill required fields by clicking on "More Options"')}</p>
            </div>}
            {!this.props.isChildKr && this.state.suggestedVisible && this.state.tagsList && this.state.tagsList.length ? (
              <>
                <div className="parent-temp">
                  <div className="container-temp">
                    <div
                      className="suggestion-temp"
                      tabIndex={'0'}
                      aria-label={t("Remove Suggested Tags")}
                      data-testid="suggestion-tag-text"
                    >
                      {
                        <ImgIconComp
                          id="kr_cluster_1x"
                          width="20px"
                          height="20px"
                          class="lightBlub"
                        />
                      }
                      {/* <span
                       role='option'
                       aria-label='Remove Suggested Tags'
                        tabIndex={'0'}
                        // aria-selected ={suggestedVisible}
                        // aria-selected ={suggestedVisible()}
                        onKeyPress={() =>
                          this.setState({ suggestedVisible: false })
                        }
                        onClick={() =>
                          this.setState({ suggestedVisible: false })
                        }
                      >
                        X
                      </span> */}
                      { this.state.tagsList && this.state.tagsList.length > 0 ? this.state.tagsList.length : ''}
                      &nbsp;<div> {t('Suggested Tags')}</div>
                      <StyledIconButton
                        data-testid="closeSuggestion"
                        role="option"
                        aria-label={t("Remove Suggested Tags")}
                        className=""
                        aria-selected={this.suggestedVisible}
                        onKeyPress={() => this.styledButtonClicked()}
                        onClick={() => this.styledButtonClicked()}
                      >
                        <Clear />
                      </StyledIconButton>

                    </div>
                    <div className='right-temp'>
                    {/* <div className="right-temp" data-testid="right-temp"  role="application"> */}
                      {this.state.tagsList &&
                        this.state.tagsList.length > 0 &&
                        this.state.tagsList.slice(0, 5).map((item, i) => (
                          <div
                            key = {i}

                            data-testid="nlp-tags"
                            role="option"
                            aria-selected={this.retnActiveClass(i)}
                            className={this.toggleActiveClass(i)}
                            id={item.id}
                            tabIndex={0}
                            onKeyDown={(e) => {
                              if (e.keyCode === 32 || e.keyCode === 13) {
                                this.toggleClass(i)
                                e.preventDefault()
                              }
                            }}
                            onClick={() => {
                              this.toggleClass(i)
                            }}

                          >
                            <span>{this.toggleActiveIcon(i)}</span>
                            <div>{' ' + item.name}</div>
                            {item.name.length>20 &&
                            <div title={item.name}>...</div>
                             }
                          </div>
                        ))}
                    </div>
                  </div>
                  <div className="advance-temp">
                    {t('Looking for different tags?')}
                    <span
                      role="option"
                      aria-label={t("Add additional tags")}
                      tabIndex={'0'}
                      // aria-selected ={suggestedVisible}
                      onKeyPress={this.setRightPaneValue}
                      onClick={this.setRightPaneValue}
                      data-testid="more-option-link"
                    >
                      {t('Add additional tags')}
                    </span>
                  </div>
                </div>
              </>
            ) : null}
            <div className="saveKrBtn">
              <Button
                variant="primary"
                size="medium"
                kind="normal"
                onClick={this.saveKr}
                disabled={this.state.saveBtn}
                data-testid="saveKrNow"
              >
                {t('Save')}
              </Button>
              <Button
                className="basicKrLink"
                data-testid="moreOptions"
                variant="ghost"
                kind="normal"
                onClick={this.setRightPaneValue}
              >
                {t('More options')}
              </Button>
            </div>
          </div>
        </div>
        <Notification
          open={this.state.notification}
          message={`${this.state.currentTagname} ${t('have been')} ${this.state.addRemove} ${t('key result.')}`}
          severity={this.state.severity}
          anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }}
          onClose={() => {
            this.setState({ notification: false })
            this.setState({ severity: '' })
          }}
        />
      </ThemeProvider>
    )
  }
}


export default withTranslation()(BasicKrComp);
